// extracted by mini-css-extract-plugin
export default {"iframeHeader":"Chat_iframeHeader__xkK0C","nextButton":"Chat_nextButton__8Krfl","icons":"Chat_icons__e26vy"};